import * as crypto from 'crypto-js';


export class LocalService {

  static set(key: string, value: any): void {
    value = LocalService.bsEncrypt(value);
    localStorage.setItem(key, value);
  }

  static get(key: string): any {
    const raw = localStorage.getItem(key);
    let data = LocalService.bsDecrypt(raw);
    if (data != null) {
      try {
        return JSON.parse(data);
      } catch (error) {
        console.log(error);
      }
    }
    return null;
  }

  static flush(key?: string): void {
    if (key != null && key != undefined) {
      localStorage.removeItem(key);
    } else {
      localStorage.clear();
    }
  }

  static bsEncrypt(data: string): string {
    let string: any = JSON.stringify(data);
    return crypto.AES.encrypt(string, 'asdfasfd').toString();
  }

  static bsDecrypt(data: string | null): string | null {
    if (!data) {
      return data;
    }
    try {
      let string: any = crypto.AES.decrypt(data, 'asdfasfd');
      return string.toString(crypto.enc.Utf8);
    } catch (error) {
      return null;
    }
  }
}
